import React, { Component } from 'react'
import {firestore} from '../../firebase/firebase.utils'
import './item.styles.scss'
import { connect } from "react-redux";
import { addItem } from "../../redux/cart/cart.actions";
import CustomButton from '../../components/custom-button/custom-button.component'
import IconButton from '@material-ui/core/IconButton';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import StyledHero from '../../components/StyledHero'
import Hero from '../../assets/shop.png'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import {Helmet } from 'react-helmet'
import Banner from '../../components/banner'

class Item extends Component {
    state = {
        item: {

        },
        loading: true,
        items: [],
        share:{
            displayNames: true,
            config: [{
                  facebook: {
                    socialShareUrl: window.location.href,
                  }
                },
                {
                  twitter: {
                    socialShareUrl: window.location.href,
                },
                
            }]
        }
    }
    componentDidMount(){
        window.scrollTo(0, 0)
        const {match} = this.props
        const that = this
        let c = []
        firestore.collection("collections").get()
        .then(function(querySnapshot) {
            querySnapshot.forEach(async function(doc) {
                c.push(doc.data())
                // that.setState({reviews:c})
                c.forEach(item => {
                    item.items.forEach(element => {
                        // console.log(element.slug);
                        let m = '/'.concat(element.slug) 
                        // that.setState({
                        //     items: element
                        // })
                        if (m === encodeURI(match.url)){
                            that.setState({
                                item: element,
                                loading:false
                            })
                        }
                    });
                })
            });
        })
        .catch(function(error) {
            console.log("Error getting documents: ", error);
        });
    }

    render() {  
    
        if(this.state.loading===true){      
        return (
            <div className="SpinnerOverlay">
                <div className="SpinnerContainer"/>
            </div>
        )
    }
    else{
        const {name,price,imageUrl,description,metaDesc,metaTitle} = this.state.item
        const {addItem} = this.props;
        return (
            <div style={{overflowX:"none"}}>
                <Helmet>
                <meta charset="utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <meta name="description" content={metaDesc}/>
                <title>{metaTitle}</title>
                </Helmet>
                    {/* <CustomButton className="custom-buton" onClick={() => addItem(this.state.item)} type="button">
                    <IconButton>
                        <AddShoppingCartIcon style={{color:'white'}} />
                        </IconButton>
                        Add to Cart
                    </CustomButton> */}
                    <StyledHero img={Hero} mob={Hero}>
                        <Banner title={name} subtitle='Back to Shop'/>
                </StyledHero>
                <div className="item-page">
                <div className="item">
                    <div className="carousel" style={{backgroundColor:"white"}}>
                <Carousel style={{backgroundColor:"white"}} infiniteLoop useKeyboardArrows showThumbs={false} autoPlay>
                {/* {photos.map((item,id)=>( */}
                                <img src={imageUrl} alt={metaTitle} style={{backgroundColor:"white",objectFit:"contain",widht:"500px",height:"500px"}}/>
                            {/* )) */}
                {/* } */}
                </Carousel>
                </div>
                <div className="D">
                    <div className="cartPrice">
                        <div className="single">{name}</div>
                        <h2 style={{fontSize:"8px",opacity:"0.5"}}>{metaTitle}</h2>
                        <div className="singlep">RP{price}</div>
                        <div className="singleb">
                            <h2>Description</h2>
                            <p>{description}</p>
                        </div>
                    </div>
                    <div className="breif">
                    <div className="singleb"></div>
                    <CustomButton className="custom-button" style={{width:"300px",fontSize:"20px"}} onClick={() => addItem(this.state.item)} type="button">
                    <IconButton>
                        <AddShoppingCartIcon style={{color:'white'}} />
                        </IconButton>
                        Add to Cart
                    </CustomButton>
                    </div>
                </div>
                </div> 
                </div>  
                {/* <ScrollableTabsButtonForce description={description}/> */}
                </div>  
        )
    }
    }
}
const mapDispatchToProps = dispatch => ({
    addItem: item => dispatch(addItem(item))
});
export default connect(null,mapDispatchToProps)(Item);